import axiosInstance from "../utilities/axiosSetup";
export const list_customers = async (page, page_size, search_text) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-customers",
      {
        params: { page, page_size: page_size, search_text: search_text },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const get_customer = async (id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-customer-by-id",
      {
        params: { customer_id: id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const get_customer_info = async (id) => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-customer-info",
      {
        params: { engagement_id: id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const insert_customer = async (data) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/insert-customer",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const update_customer = async (data) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/edit-customer",
      data,
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const change_customer_password = async (
  customer_id,
  password,
  confirm_password
) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/change-customer-password",
      { customer_id: customer_id, password, confirm_password },
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const delete_customer = async (customer_id) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/delete-customer",
      { customer_id: customer_id },
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const create_customer_video = async (payload) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/create-customer-video",
      payload,
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const create_customer_video_bulk = async (payload) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/create-customer-video-bulk",
      payload,
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const list_customer_video_portal_accounts = async (
  customer_id,
  page = 1,
  per_page = 10
) => {
  try {
    const response = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-customer-video-portal-accounts",
      {
        params: { customer_id, page, per_page },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const get_customer_video_accounts_to_download = async (customer_id) => {
  try {
    const response = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/get-customer-video-accounts-to-download",
      {
        params: { customer_id },
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const delete_customer_video = async (customer_id, account_id) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/delete-video-customer",
      { customer_id, customer_video_account_id: account_id },
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const update_customer_video = async (
  customer_id,
  customer_video_account_id,
  payload
) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/update-customer-video",
      { customer_id, customer_video_account_id, ...payload },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const reset_video_password = async (
  customer_id,
  customer_video_account_id,
  password,
  confirm_password
) => {
  try {
    const response = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/reset-video-password",
      {
        customer_id,
        customer_video_account_id,
        password,
        confirm_password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
